;(function () {
  'use strict'
  angular.module('obex').factory('socketLogin', [
    '$rootScope',
    'socket',
    function ($rootScope, socket) {
      var _socketId = null
      var _loginMember = null
      return {
        setSocketIdAndSend(socketId) {
          // _socketId && _socketId.length
          //   ? socket.sendClientDisconnect(socketId)
          //   : ''
          console.log('old socketID', _socketId)
          _socketId = socketId
          if (_loginMember) {
            var space = '  '
            socket.sendClientConnect(_socketId, _loginMember)
          }
        },

        setLoginMemberAndSend(loginMember) {
          _loginMember = loginMember
          if (_socketId) {
            socket.sendClientConnect(_socketId, _loginMember)
          }
        },

        getSocketId() {
          return _socketId
        },

        getLoginMember() {
          return _loginMember
        },
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/socketlogin.service.js